import request from '@/utils/request'

// 查询操作记录分页
export function pageOperationRecord(data) {
  return request({
    url: '/cloudplant/operationRecord/page',
    method: 'post',
    data: data
  })
}

// 查询操作记录详情
export function getOperationRecord(data) {
  return request({
    url: '/cloudplant/operationRecord/detail',
    method: 'get',
    params: data
  })
}

// 处理操作记录
export function handleOperationRecord(data) {
  return request({
    url: '/cloudplant/operationRecord/handle',
    method: 'post',
    data: data
  })
}
